export default class VideoSorter {
    constructor() {
        this.initSorter();
    }

    initSorter() {
        const buttons = document.querySelectorAll('[data-video-category-button]');
        const items = document.querySelectorAll('.video-teaser-list li');

        if (!buttons.length || !items.length) return;

        const showAll = () => {
            items.forEach(item => item.style.display = 'block');
        };

        const setActiveButton = (activeBtn) => {
            buttons.forEach(b => b.classList.add('button--outline'));
            activeBtn.classList.remove('button--outline');
        };

        showAll();
        const defaultButton = document.querySelector('[data-video-category-button=""]');
        if (defaultButton) setActiveButton(defaultButton);

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                const category = btn.getAttribute('data-video-category-button');

                setActiveButton(btn);

                items.forEach(item => {
                    const itemCategory = item.getAttribute('data-video-category');
                    const shouldShow = category === '' || itemCategory === category;
                    item.style.display = shouldShow ? 'block' : 'none';
                });
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new VideoSorter();
});
